import { DeepPartial } from '@luggagehero/shared/interfaces';
import { createAction, props } from '@ngrx/store';

import { OrderRequest } from './order-requests.models';

export const updateOrderRequest = createAction(
  '[Order Request] Update',
  props<{ updates: DeepPartial<OrderRequest> }>(),
);
